// @ts-strict-ignore
import { PropertyVO } from '@project/components/article/model/vo/property.vo';
import { MetaElementVO } from '@shared/vo/meta-element.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('CompositeArticleConfigurationVO')
export class CompositeArticleConfigurationVO {
  public static readonly CLASS_NAME: string = 'CompositeArticleConfigurationVO';

  @JsonProperty('type', 'String')
  public type: string = undefined;

  @JsonProperty('compositeArticleId', 'Number')
  public compositeArticleId: number = undefined;

  @JsonProperty('compositeArticleNo', 'String')
  public compositeArticleNo: string | undefined = undefined;

  @JsonProperty('behaviorProperties', '[PropertyVO]')
  public behaviorProperties: PropertyVO[] = [];

  public constructor() {
    this.type = CompositeArticleConfigurationVO.CLASS_NAME;
  }

  public toJSON() {
    return {
      type: this.type,
      compositeArticleId: this.compositeArticleId,
      compositeArticleNo: this.compositeArticleNo,
      behaviorProperties: this.behaviorProperties
    };
  }
}

@JsonObject('CompositeConfigurationByGivingAreasVO')
export class CompositeConfigurationByGivingAreasVO extends CompositeArticleConfigurationVO {
  public static readonly CLASS_NAME: string = 'CompositeConfigurationByGivingAreasVO';

  @JsonProperty('givingAreas', '[MetaElementVO]')
  public givingAreas: MetaElementVO[] = [];

  public constructor() {
    super();
    this.type = CompositeConfigurationByGivingAreasVO.CLASS_NAME;
  }

  // override default object method toJSON() (which is invoked when the object should be serialized)
  // to exclude transient properties and send correct object to server
  public toJSON() {
    const object = super.toJSON();
    object['givingAreas'] = this.givingAreas;
    return object;
  }
}

@JsonObject('CompositeConfigurationByBaseArticleVO')
export class CompositeConfigurationByBaseArticleVO extends CompositeArticleConfigurationVO {
  public static readonly CLASS_NAME: string = 'CompositeConfigurationByBaseArticleVO';

  @JsonProperty('baseArticleId', 'Number')
  public baseArticleId: number = undefined;

  @JsonProperty('baseArticleVersion', 'Number')
  public baseArticleVersion: number = undefined;

  @JsonProperty('baseArticleUsageId', 'String')
  public baseArticleUsageId: string = undefined;

  public constructor() {
    super();
    this.type = CompositeConfigurationByBaseArticleVO.CLASS_NAME;
  }

  // override default object method toJSON() (which is invoked when the object should be serialize)
  // to exclude transient properties and send correct object to server
  public toJSON() {
    const object = super.toJSON();
    object['baseArticleId'] = this.baseArticleId;
    object['baseArticleVersion'] = this.baseArticleVersion;
    object['compositeArticleNo'] = this.compositeArticleNo;
    return object;
  }
}
